module.exports = __webpack_public_path__ + "static/img/monijisuan.caae67b8.jpg";